import { Link } from "react-router-dom"
import styled from "styled-components"
import { ContainerFull } from "../components/GeneralComponents"

const H1 = styled.h1`
    font-size: 1.6rem;
    color: ${(props) => props.theme.primary};
    margin-bottom: 0.7em;
`
const H2 = styled.h2`
    font-size: 1.15rem;
    margin-top: 1.5em;
    margin-bottom: 0.5em;
`

export function FAQ(): JSX.Element {
    return (
        <ContainerFull style={{ fontFamily: '"Rubik", sans-serif', maxWidth: 800, margin: "0 auto" }}>
            <H1>Frequently Asked Questions (FAQ)</H1>
            <div style={{ marginBottom: 24 }}>
                <H2>How do I place an order?</H2>
                <p>
                    Go to the "Order" page, fill in the required information, and submit your order. You will receive a
                    confirmation email after submission.
                </p>
            </div>
            <div style={{ marginBottom: 24 }}>
                <H2>How can I view my order details and results?</H2>
                <p>
                    After logging in, go to "My Orders." Click on any order to view its details, download results, or
                    view invoices.
                </p>
            </div>
            <div style={{ marginBottom: 24 }}>
                <H2>How do I ask questions or leave comments about my order?</H2>
                <p>
                    On the order details page, you can use the "Questions and Feedback" to leave a
                    comment or ask a question about your order. Our team will respond directly in the same section, and
                    you will be notified by email when there is a new response.
                </p>
            </div>
            {/* <div style={{ marginBottom: 24 }}>
                <H2>How do I change or cancel my order?</H2>
                <p>
                    All orders are final. If you need further assistance 
                    You can change the status of your order from "new" to "canceled", as long as processing has not started.
                </p>
            </div> */}
            <div style={{ marginBottom: 24 }}>
                <H2>Who do I contact for support?</H2>
                <p>
                    You can email <a href="mailto:support@plabsequencing.com">support@plabsequencing.com</a> for any
                    issues. For order related issues, we recommend using the "Questions and Feedback" feature on your order page for faster and more organized responses.
                </p>
            </div>
            <div style={{ marginBottom: 24 }}>
                <H2>Can I request to re-run a sample?</H2>
                <p>
                    You can request a manual review of the samples through the order details page.
                    There will be a check box "Request review" for each sample if the analysis is complete.
                    We suggest you add comments in the "Questions and Feedback" section as well so we know what the problem is.
                    Once we received the requests, we will review it and determine whether we need to redo the bioinformatics or the sequencing.
                    We will communicate back to you through the "Questions and Feedback" section in the order details page.
                </p>
            </div>
            <div style={{ marginBottom: 24 }}>
                <H2>Where can I find the terms and conditions?</H2>
                <p>
                    The terms and conditions are available at the bottom of our website or <Link to="/terms">here</Link>
                    .
                </p>
            </div>
        </ContainerFull>
    )
}
